const additionalFeatures = [
  {
    icon: 'ri-bar-chart-box-line',
    color: 'bg-orange-50 text-orange-500',
    title: 'A/B Testing Variations',
    description: 'Generate up to 20 unique ad variants from a single prompt. Different hooks, different angles, different tones — so you can test your way to a winning ad.',
  },
  {
    icon: 'ri-global-line',
    color: 'bg-amber-50 text-amber-600',
    title: 'Multi-Platform Formatting',
    description: 'Each ad is auto-formatted for your target platform — correct character limits, image ratios, and tone conventions for Facebook, Instagram, Google, TikTok, and LinkedIn.',
  },
  {
    icon: 'ri-building-line',
    color: 'bg-rose-50 text-rose-500',
    title: 'Business Profiles',
    description: 'Save your business details, tone of voice, and audience once. Every future generation is pre-loaded with your brand context — no re-entering info every time.',
  },
  {
    icon: 'ri-history-line',
    color: 'bg-teal-50 text-teal-600',
    title: 'Ad History & Library',
    description: 'Every ad you generate is saved to your account. Browse, copy, edit, or regenerate past ads anytime. Your full ad creative library, always available.',
  },
  {
    icon: 'ri-compass-3-line',
    color: 'bg-violet-50 text-violet-600',
    title: 'Ad Angle Controls',
    description: 'Choose your campaign strategy: Problem/Solution, Before/After, Offer-driven, Emotional, or Authority. Or let the AI pick the best angle for your offer.',
  },
  {
    icon: 'ri-loop-left-line',
    color: 'bg-emerald-50 text-emerald-600',
    title: 'Regenerate Individual Elements',
    description: 'Not happy with one image or one headline? Regenerate just that element without touching the rest of your ad. Iterate fast, waste nothing.',
  },
  {
    icon: 'ri-team-line',
    color: 'bg-orange-50 text-orange-500',
    title: 'Agency Multi-Account',
    description: 'Manage multiple client business profiles from one dashboard. Generate ads for different clients without switching accounts or losing context.',
  },
  {
    icon: 'ri-download-cloud-2-line',
    color: 'bg-amber-50 text-amber-600',
    title: 'One-Click Export',
    description: 'Download your finished ad creatives in the correct platform dimensions — PNG, JPG, or PDF. Copy ad text to clipboard instantly and paste into your ad manager.',
  },
  {
    icon: 'ri-shield-check-line',
    color: 'bg-rose-50 text-rose-500',
    title: 'Secure & Private',
    description: 'Your business data and ad content are never shared or used to train other AI models. Full data privacy, SOC2-compliant infrastructure.',
  },
];

export default function FeaturesGrid() {
  return (
    <section className="py-20 lg:py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-xs font-bold uppercase tracking-widest text-orange-500 mb-3 block">Full Feature List</span>
          <h2 className="text-3xl lg:text-4xl font-black text-stone-900 mb-4 leading-tight">
            Everything Else That Makes AdForge the Best AI Ad Generator
          </h2>
          <p className="text-stone-500 text-base leading-relaxed">
            Beyond the three core pillars, AdForge is packed with tools designed to make every step
            of the ad creation process faster and smarter.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {additionalFeatures.map((f) => (
            <div
              key={f.title}
              className="bg-white rounded-2xl border border-stone-100 p-6 hover:border-orange-200 hover:-translate-y-0.5 transition-all duration-200 cursor-default"
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-xl mb-4 ${f.color}`}>
                <i className={`${f.icon} text-lg`} />
              </div>
              <h3 className="text-sm font-bold text-stone-900 mb-2">{f.title}</h3>
              <p className="text-xs text-stone-500 leading-relaxed">{f.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
